module.exports = __webpack_public_path__ + "static/media/doremi_00188.51059c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/doremi_00188.png
// module id = 70
// module chunks = 0